import { ImageConfig } from "../../models/client";
import { ApiImage } from "../../models/api/image";

export function toImageConfig(image: ApiImage): ImageConfig {
  const rootSrc = process.env.REACT_APP_MEDIA_URL;

  if (!image.Src) {
    return {
      src: "",
      title: "",
      fit: "cover",
    };
  }
  return {
    src: image.Src.includes("/API/API")
      ? rootSrc + image.Src.slice(4, image.Src.length)
      : rootSrc + image.Src,
    title: image.Title,
    fit: image.Fit,
  };
}
